import Image from 'next/image'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { globalUserProxy } from '../../../../shared/proxies/globalUserProxy'

export function UserInfo (): ReactElement {
  const { user } = useSnapshot(globalUserProxy)
  return (
    <div className="flex flex-col items-center justify-center">
      <Image alt="User avatar" src="/user.svg" height={80} width={80} />
      <div className="font-medium">
        {user?.firstName} {user?.lastName}
      </div>
      <div className="text-sm text-gray-400">
        {user?.email}
      </div>
      <div className="text-sm text-gray-400">
        {user?.merchant.merchantName}
      </div>
    </div>
  )
}
